package com.example.mystybag.sharedmodels.project.requestModels.reservations

import com.example.mystybag.sharedmodels.AllCommands.CREATE_REVIEW
import com.example.mystybag.sharedmodels.base.BaseRequestModel
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
class CreateReviewRequestModel(
    val userId: Long = 0L,
    val reservationId: Long = 0L,
    val merchantLocationId: Long = 0L,
    val businessCategoryId: Long = 0L, // Business category ID to determine which rating categories to use
    // The following 4 fields represent the 4 rating categories for the business category
    // The meaning of each field depends on businessCategoryId:
    // - For food categories: category1=freshness/taste, category2=quality, category3=variety/portion_size, category4=value
    // - For service categories: category1=service_quality, category2=professionalism, category3=atmosphere/hygiene, category4=value
    // - etc. See ReviewCategoryConfigs for full mapping
    // Using @SerialName to maintain backward compatibility with existing API
    val ratingCollectionExperience: Int = 0, // 1-5 - First rating category (varies by business category)
    val ratingFoodQuality: Int = 0, // 1-5 - Second rating category (varies by business category)
    val ratingVarietyOfContents: Int = 0, // 1-5 - Third rating category (varies by business category)
    val ratingFoodQuantity: Int = 0, // 1-5 - Fourth rating category (varies by business category)
    /** Optional: up to 3 "could be better" aspect ids as int (e.g. enum ordinal: 0=PRICE, 1=PICKUP_TIME, 2=BAG_VARIETY, 3=PACKAGING, 4=STAFF_ATTITUDE). */
    val couldBeBetterAspects: List<Int>? = null,
    /** Optional comment, max 200 characters. */
    val comment: String? = null
) : BaseRequestModel(api = CREATE_REVIEW)

